import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as myClassAPI from "../../api/classes";
import { toast } from "react-toastify";

const initialState = {
  data: null,
  loading: false,
  activeClass: null,
  upload: {
    loading: false,
  },
};

const addClasses = createAsyncThunk(
  "myClass/addClasses",
  async (params, { rejectWithValue }) => {
    try {
      const res = await myClassAPI.addClasses(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      if (res.data.body) {
        // toast.success(res.data.body);
      }

      return res.data.body;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

const updateClasses = createAsyncThunk(
  "myClass/updateClasses",
  async (params, { rejectWithValue }) => {
    try {
      const res = await myClassAPI.updateClasses(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

const getClasses = createAsyncThunk(
  "myClass/getClasses",
  async (params, { rejectWithValue }) => {
    try {
      const res = await myClassAPI.getClasses(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

const deleteClasses = createAsyncThunk(
  "myClass/deleteClasses",
  async (params, { rejectWithValue }) => {
    try {
      const res = await myClassAPI.deleteClasses(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

const classesSlice = createSlice({
  name: "myClass",
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
    getActiveClass: (state, action) => {
      const currentIndex = state.data.classes.findIndex(
        (_el) => _el.id === action.payload
      );
      state.activeClass = state.data.classes[currentIndex];
    },
    setActiveClasses: (state, action) => {
      state.activeClass = action.payload;
    },
  },
  extraReducers: {
    [addClasses.pending]: (state) => {
      state.upload.loading = true;
    },
    [addClasses.fulfilled]: (state, action) => {
      state.upload.loading = false;
      toast.success(action.payload);
    },
    [addClasses.rejected]: (state, action) => {
      toast.error(action.payload);
      state.upload.loading = false;
    },

    [updateClasses.pending]: (state) => {
      state.loading = true;
    },
    [updateClasses.fulfilled]: (state, action) => {
      state.loading = false;
      toast.success(action.payload);
    },
    [updateClasses.rejected]: (state) => {
      state.loading = false;
    },

    [getClasses.pending]: (state) => {
      state.loading = true;
    },
    [getClasses.fulfilled]: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    [getClasses.rejected]: (state) => {
      state.loading = false;
    },

    [deleteClasses.pending]: (state) => {
      state.loading = true;
    },
    [deleteClasses.fulfilled]: (state, action) => {
      state.loading = false;
      toast.success(action.payload);
    },
    [deleteClasses.rejected]: (state) => {
      state.loading = false;
    },
  },
});

const { resetState, getActiveClass, setActiveClasses } = classesSlice.actions;

export default classesSlice.reducer;

export {
  resetState,
  addClasses,
  updateClasses,
  getClasses,
  deleteClasses,
  getActiveClass,
  setActiveClasses,
};
